import { render, staticRenderFns } from "./ComposableProduct.vue?vue&type=template&id=5bbb19ce&scoped=true&"
import script from "./ComposableProduct.vue?vue&type=script&lang=js&"
export * from "./ComposableProduct.vue?vue&type=script&lang=js&"
import style0 from "./ComposableProduct.vue?vue&type=style&index=0&id=5bbb19ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb19ce",
  null
  
)

export default component.exports